import React from 'react';
import { FicheAutoControleCritere } from '../../../store/types/FicheAutocontrole.Types';
import { ApplicationState } from '../../../store/store/store';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { GoBackCurrentState, GoBackCurrentStateActions } from '../../../store/types/GoBackState.Types';
import { connect } from 'react-redux';
import CounterAutocontrole from './CounterAutocontrole';
import { LabelCritereSelectAutocontroleStyled } from '../../../styles/CritereAutocontrole.style';
import { TextField } from '@material-ui/core';

interface PropsFromState {
    critere: FicheAutoControleCritere,
    updateCritere: Function
}

interface PropsFromDispatch {
    goBackStateHasChanged: Function,
    goBackState: GoBackCurrentState
}

type AllProps = PropsFromDispatch & PropsFromState

const ReserveAutocontrole: React.FC<AllProps> = ({ critere, updateCritere, goBackStateHasChanged }) => {

    const PRE_DELIVERY = "PRE_DELIVERY";
    const REMAINING_PRE_DELIVERY = "REMAINING_PRE_DELIVERY";
    const NEW_DELIVERY = "NEW_DELIVERY";

    const handleLotNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        goBackStateHasChanged();
        updateCritere({
            ...critere,
            deliveryReserve: { ...critere.deliveryReserve, lotNumber: event.target.value },
        });
    };

    const handleCounterChange = (field: string) => (counterValue: FicheAutoControleCritere) => {
        goBackStateHasChanged();
        let updatedReserve = { ...critere.deliveryReserve };

        switch (field) {
            case PRE_DELIVERY:
                updatedReserve.preDeliveryReservesCount = counterValue.value as number;
                break;
            case REMAINING_PRE_DELIVERY:
                updatedReserve.remainingPreDeliveryReservesCount = counterValue.value as number;
                break;
            case NEW_DELIVERY:
                updatedReserve.newDeliveryReservesCount = counterValue.value as number;
                break;
            default:
                break;
        }

        updateCritere({
            ...critere,
            deliveryReserve: updatedReserve,
        });
    };

    const getCounterCritere = (field: string): FicheAutoControleCritere => {
        let value = 0;
        if (critere.deliveryReserve) {
            switch (field) {
                case PRE_DELIVERY:
                    value = critere.deliveryReserve.preDeliveryReservesCount || 0;
                    break;
                case REMAINING_PRE_DELIVERY:
                    value = critere.deliveryReserve.remainingPreDeliveryReservesCount || 0;
                    break;
                case NEW_DELIVERY:
                    value = critere.deliveryReserve.newDeliveryReservesCount || 0;
                    break;
                default:
                    value = 0;
            }
        }
        return { ...critere, value };
    };

    return (
        <div key={critere.id} className="delivery-autocontrole-row">

            <div className="delivery-autocontrole-main">
                <div className="delivery-autocontrole-label">
                <LabelCritereSelectAutocontroleStyled>
                    {critere.title}
                </LabelCritereSelectAutocontroleStyled>
                </div>

                <div className="critera-input-text-box">
                <TextField
                    value={critere.deliveryReserve?.lotNumber || ''}
                    onChange={handleLotNumberChange}
                    placeholder="Numéro de Lot"
                />
                </div>
            </div>

            <div className="delivery-autocontrole-counter">
                <CounterAutocontrole critere={getCounterCritere(PRE_DELIVERY)} updateCritere={handleCounterChange(PRE_DELIVERY)} />
            </div>
            <div className="delivery-autocontrole-counter">
                <CounterAutocontrole critere={getCounterCritere(REMAINING_PRE_DELIVERY)} updateCritere={handleCounterChange(REMAINING_PRE_DELIVERY)} />
            </div>
            <div className="delivery-autocontrole-counter">
                <CounterAutocontrole critere={getCounterCritere(NEW_DELIVERY)} updateCritere={handleCounterChange(NEW_DELIVERY)} />
            </div>
        </div>
    );
};


const mapStateToProps = ({ goBackState }: ApplicationState) => ({
    goBackState: goBackState
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        goBackStateHasChanged: () => dispatch({ type: GoBackCurrentStateActions.CHANGING_STATE })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserveAutocontrole);